import { Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CardCitroen from '../../Cards/NewOffersCitroen/index';
import CardPsa from '../../Cards/Psa/index';
import CardFca from '../../Cards/Fca/index';
import CardRAM from '../../Cards/NewsOffersRam/index';
import ItemPlaceholder from './ItemPlaceholder';
import ButtonLoadMore from './ButtonLoadMore';
import { cardDDMOffersLink } from '../../../helpers';

class OfferDDMList extends Component {
  getCard(brand = 'citroen') {
    const brandLowercased = brand.toLocaleLowerCase();

    const cards = {
      citroen: CardCitroen,
      peugeot: CardPsa,
      fiat: CardFca,
      jeep: CardFca,
      ram: CardRAM,
    };

    return cards[brandLowercased];
  }

  getGridLargeColumns(brand = 'citroen') {
    const brandLowercased = brand.toLocaleLowerCase();

    const columns = {
      citroen: 'col-lg-3',
      peugeot: 'col-lg-3',
      fiat: 'col-lg-4',
      jeep: 'col-lg-4',
      ram: 'col-lg-4',
    };

    return columns[brandLowercased];
  }

  sealListLowercased(sealList) {
    return sealList.map(seal => seal.toLocaleLowerCase());
  }

  showBadge(basedType) {
    return basedType.includes('Hub') || basedType.includes('Marketplace');
  }

  render() {
    const {
      items,
      loading,
      showLoadMore,
      onClickButtonLoadMore,
      loadingMore,
      channelUrl,
      brand,
      customCard,
      customColumns,
    } = this.props;

    const Card = customCard || this.getCard(brand);
    const gridColumns = customColumns || this.getGridLargeColumns(brand);

    return (
      <div className="list-offers__list">
        <div className="row list-offers__list-row">
          {items.map(offer => (
            <div
              className={classNames(
                'col-md-6 list-offers__col-card',
                gridColumns,
              )}
            >
              {loading ? (
                <ItemPlaceholder />
              ) : (
                <Card
                  title={offer.name}
                  subtitle={offer.model}
                  image={offer.thumbs.middle_image}
                  sealList={this.sealListLowercased(
                    offer.seal_list.slice(0, 3),
                  )}
                  link={cardDDMOffersLink(
                    offer.base_type,
                    offer.slug,
                    channelUrl,
                  )}
                  offer={offer.item_offer}
                  lazy
                  showBadge={this.showBadge(offer.base_type)}
                  badge={offer.category}
                  showExpiredAt={!!offer.expired_at}
                  expiredAt={offer.expired_at}
                />
              )}
            </div>
          ))}
        </div>
        {showLoadMore && (
          <div className="list-offers__show-more">
            <ButtonLoadMore
              onClick={onClickButtonLoadMore}
              loading={loading}
              loadingMore={loadingMore}
            />
          </div>
        )}
      </div>
    );
  }
}

OfferDDMList.defaultProps = {
  items: [],
  loading: false,
  loadingMore: false,
  showLoadMore: false,
  channelUrl: '',
  brand: '',
  onClickButtonLoadMore: () => {},
  customCard: null,
  customColumns: null,
};

OfferDDMList.propTypes = {
  items: PropTypes.arrayOf,
  showLoadMore: PropTypes.bool,
  loading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  channelUrl: PropTypes.string,
  brand: PropTypes.string,
  onClickButtonLoadMore: PropTypes.func,
  customCard: PropTypes.element,
  customColumns: PropTypes.string,
};

export default OfferDDMList;
